module.exports = __webpack_public_path__ + "img/4.815edcf2.svg";